/**
 * Small marker above an avatar for its activity (spec §6.5: "playing" icon at a game station).
 * Activity keys are `verb` or `verb:detail`; the verb picks the icon.
 */
const ICONS: Readonly<Record<string, string>> = {
  playing: '🎮',
  drinking: '☕',
  eating: '🍬',
  working: '💻',
};

/** Icon for an activity key, a neutral dot for unknown verbs, or `''` when idle. */
export function activityIcon(activity: string): string {
  if (!activity) return '';
  const verb = activity.split(':', 1)[0] ?? '';
  return ICONS[verb] ?? '•';
}
